export enum ErrorType {
  NoToken = 'NoToken',
  NotFound = 'Order.NotFound',
  AlreadyAppointed = 'Order.AlreadyAppointed',
  Closed = 'Order.Closed',
  TimeSlotNotAccepted = 'Order.TimeSlotNotAccepted',
  NoTimeSlotsFound = 'Order.NoTimeSlotsFound',
  AdditionalServices = 'Order.AdditionalServices',
  Expired = 'Order.Expired',
}
